module.exports = __webpack_public_path__ + "img/UnityFrameworkTPSBehaviour.cf2eeca9.gif";